import { useState } from 'react';
import woman from '../../common/assets/woman.webp';

export default function ProgressiveMainHero() {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className='home-page__circle'>
      <img
        className='home-page__circle-image'
        src={'./woman-low.webp'}
        alt='hero-low'
        style={{
          opacity: loaded ? 0 : 1,
          filter: 'blur(10px)',
          transition: 'opacity 0.6s ease-in-out',
        }}
      />
      <img
        className='home-page__circle-image'
        src={woman}
        alt='hero'
        onLoad={() => setLoaded(true)}
        style={{
          opacity: loaded ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out',
        }}
      />
    </div>
  );
}
